<!--
   V 0.1.0 - 2024-12-18
      - Adapted from time line for Raptor Web
      - Comented out print

-->
<template>
  <div ref="printTest">
    <v-card>
      <v-card-title>

         <v-btn class="mx-2"
                 fab
                 dark
                 color="indigo"
                 :to="`/${previousPage}/${UnitID}/${VehicleReg}/${dayDate}`">
            <v-icon dark> mdi-arrow-left-circle </v-icon>
          </v-btn>

          {{ VehicleReg }}
          <v-divider class="mx-4" vertical></v-divider>

          <v-card-title>
            <DatePick v-model="pickerDate" formatControl="EEE, MMM do yyyy" />
          </v-card-title>

          <v-btn-toggle>
            <v-btn @click="toggleAlternate = !toggleAlternate">
              <v-icon>mdi-format-align-center</v-icon>
            </v-btn>
          </v-btn-toggle>
      </v-card-title>
    </v-card>

    <v-row>
      <v-col>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="blue"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <!--
      ---------------------------------------------------

      Loop through timeline

      ---------------------------------------------------
  -->

    <v-timeline
      id="printMe"
      align-top
      :dense="toggleAlternate"
      v-for="n in timeSpan"
      :key="`k${n}`"
      fill-dot
      small
    >
      <!--
         DAYS
      -->
      <v-timeline-item>
        <v-card class="elevation-2">
          <v-card-title class="text-h5">
            {{ getDateFrom(n) }}
          </v-card-title>
          <v-card-text> </v-card-text>
        </v-card>
      </v-timeline-item>

      <!--
         Items for Days
      -->

      <v-timeline-item
        v-for="(item, i) in filterItemsByDay(items, n)"
        :key="i"
        :color="item.color"
        :icon="item.icon"
        small
      >
        <TripTimeLineCard
          :count="(i + 1) * (n + 1) + 10"
          :trip="item"
          :vehicle-reg="VehicleReg"
        >
        </TripTimeLineCard>

        <br />
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import { format, parseISO, addDays } from 'date-fns'
import TripTimeLineCard from '@/lib/v1/comp/TripTimeLineCard'
import DatePick from '@/lib/v1/comp/DatePick'

// import html2canvas from 'html2canvas'
// import printJS from 'print-js'

export default {
  //
  components: {
    DatePick,
    TripTimeLineCard
  },
  //
  data () {
    return {
      toggle_print: 0,

      printObj: {
        id: 'printTest',
        popTitle: 'good print'
      },

      toggleAlternate: true,

      isLoading: false,

      type: 'day',
      timeSpan: 1,
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days'
      },

      pickerDate: format(
        parseISO(addDays(new Date(), 0).toISOString()),
        'yyyy-MM-dd'
      ),

      VehicleReg: '',
      UnitID: '',
      items: []
    }
  }, // data

  mounted () {
    this.UnitID = this.$route.params.UnitID
    this.VehicleReg = this.$route.params.VehicleReg

    if (typeof this.$route.params.previousPage !== 'undefined') {
      this.previousPage = this.$route.params.previousPage
    }

    if (typeof this.$route.params.dayDate !== 'undefined') {
      this.dayDate = this.$route.params.dayDate
      this.pickerDate = this.dayDate
    }

    if (typeof this.$route.params.VehicleID !== 'undefined') {
      this.VehicleID = this.$route.params.VehicleID
    }

    if (this.$debug) {
      console.log(url) 
      console.log(`Google Maps Ver:${google.maps.version}`)
    }
  },

  computed: {
    pageHeight () {
      return document.body.scrollHeight
    },
    options () {
      return {
        duration: 7000,
        offset: 0,
        easing: 'linear'
      }
    }
  },

  watch: {
    pickerDate: {
      /*  NB! immediate: true

          This s necessary as otherwise the default for day stands
          and not that carried by prop value on startip

          immediate : trigger the callback immediately on watcher creation.
          old value will be undefined on the first call.

      */
      immediate: true,
      /**
       *   Not necessary for this as it is simple object
       *
       *   deep: force deep traversal of the source if it is an object or an array,
       *   so that the callback fires on deep mutations. See Deep Watchers.
       *
       */
      // deep: true,
      handler (valNew, valOld) {
        console.log('pickerDate')
        if (valNew !== valOld) {
          if (this.$debug) {
            console.log(valNew)
          }
          this.getData()
        }
      }
    }
  },

  created () {
    if (this.$debug) {
      console.log('created: params')
      console.log(this.$route.params)
      console.log('created: UnitID')
      console.log(this.UnitID)
    }
    this.UnitID = this.$route.params.UnitID

    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        if (this.$debug) {
          console.log('toParams:')
          console.log(toParams)
          console.log('previousParams:')
          console.log(previousParams)
          console.log(toParams.UnitID)
          console.log(toParams.Name)
        }
        this.UnitID = this.$route.params.UnitID
        this.VehicleReg = this.$route.params.VehicleReg

        this.getData()
      }
    )
  }, // created()

  methods: {
    gotoHeight: function () {
      this.$vuetify
        .goTo(this.pageHeight, this.options)
        .then(() => {
          this.printAnyMaps()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /**
     *   V 0.1.0 - 2024-05-20
     *     - https://stackoverflow.com/questions/24046778/html2canvas-does-not-work-with-google-maps-pan
     *     - https://stackoverflow.com/questions/46281261/google-map-is-not-displayed-when-using-html2canvas
     *
     */
    ///     printAnyMaps: function () {
    ///       const vm = this
    ///
    ///       const focuser = setInterval(
    ///         () => window.dispatchEvent(new Event('focus')),
    ///         500
    ///       )
    ///
    ///       html2canvas(this.$refs.printTest, {
    ///         backgroundColor: '#fff',
    ///         useCORS: true
    ///       }).then((canvas) => {
    ///         // vm.loading.close();
    ///
    ///         let orientation = 'portrait'
    ///         if (this.toggle_print == '1') {
    ///           orientation = 'landscape'
    ///         }
    ///         console.log(orientation)
    ///
    ///         const url = canvas.toDataURL('image/png')
    ///         this.htmlUrl = url
    ///         printJS({
    ///           printable: this.htmlUrl,
    ///           type: 'image',
    ///           style: [
    ///             // @
    ///             `@page { size: A4 ${orientation}; margin: 4mm;} body {margin: 0;}`
    ///           ],
    ///           showModal: true,
    ///           modalMessage: 'Preparing preview . . .',
    ///           targetStyles: ['*'],
    ///           onPrintDialogClose: function () {
    ///             vm.printModel = false //
    ///             vm.printKey = !this.printKey //
    ///             setTimeout(() => {
    ///             }, 0)
    ///             clearInterval(focuser)
    ///           }
    ///         })
    ///       })
    ///     },

    filterItemsByDay (items, day) {
      var dayConv = this.getDateFrom_yyyyMMdd(day)

      var res = items.filter((el) => {
        var start = format(
          parseISO(new Date(el.StartTime).toISOString()),
          'yyyy-MM-dd'
        )
        if (start === dayConv) {
          return true
        }
        return false
      }) // filter

      console.log(res)
      return res
    },

    getDateFrom_yyyyMMddStr (back) {
      return format(parseISO(new Date(back).toISOString()), 'yyyy-MM-dd')
    },

    getDateFrom_yyyyMMdd (back) {
      var res = addDays(new Date(this.pickerDate), -(back - 1))
      return format(res, 'yyyy-MM-dd')
    },

    getDateFrom (back) {
      var res = addDays(new Date(this.pickerDate), -(back - 1))
      return format(res, 'EEEE, MMMM do yyyy')
    },

    setInterval (key) {
      switch (key) {
      case 'week':
        this.timeSpan = 7
        this.type = 'week'
        break
      case '4day':
        this.timeSpan = 4
        this.type = '4day'
        break
      case 'day':
        this.timeSpan = 1
        this.type = 'day'
        break
      default:
        break
      }
      this.getData()
    },

    setToday () {
      this.pickerDate = format(
        parseISO(addDays(new Date(), 0).toISOString()),
        'yyyy-MM-dd'
      )
    },
    prev () {
      this.pickerDate = format(
        parseISO(
          addDays(new Date(this.pickerDate), -this.timeSpan).toISOString()
        ),
        'yyyy-MM-dd'
      )
    },
    next () {
      this.pickerDate = format(
        parseISO(
          addDays(new Date(this.pickerDate), this.timeSpan).toISOString()
        ),
        'yyyy-MM-dd'
      )
    },

    getData: function () {
      //
      if (this.$debug) {
        console.log('getData: ' + this.startTime)
      }

      var startDate = format(
        parseISO(
          addDays(new Date(this.pickerDate), -(this.timeSpan - 1)).toISOString()
        ),
        'yyyy-MM-dd'
      )

      var endDate = format(
        parseISO(addDays(new Date(this.pickerDate), 1).toISOString()),
        'yyyy-MM-dd'
      )

      this.getRemoteData(startDate, endDate).then(() => {
        console.log('Arrived')
      })
    },

    getRemoteData (start, end) {
      this.isLoading = true

      let url = `${this.$baseUrl}/api/v2/trip-extracted`

      url += `?UnitID=${this.UnitID}`
      url += `&Start=${start}`
      url += `&End=${end}`

      if (this.$debug) {
        console.log(url)
      }

      return this.$axios
        .get(url)

        .then((res) => {
          if (this.$debug) {
            console.log(res)
          }
          this.isLoading = false
          this.items = res.data
        })
        .catch((err) => {
          console.log('updateRange')
          console.log(err)
          this.isLoading = false
        })
    }
  } // methods
}
</script>
